webpackJsonp([114276838955818,60335399758886],{

/***/ 129:
/***/ (function(module, exports) {

	module.exports = {"data":{"posts":{"edges":[{"node":{"excerpt":"Hello world.\n","fields":{"slug":"/hello-world/"},"frontmatter":{"title":"Hello World","tags":["tag-1","tag-2","sample"],"subTitle":"This is placeholder dummy article","category":"testimonies","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/salty_egg-8058f3f26913fea3b6a89a73344fe94a-9e3e1.jpg","srcSet":"/static/salty_egg-8058f3f26913fea3b6a89a73344fe94a-9e3e1.jpg 1x,\n/static/salty_egg-8058f3f26913fea3b6a89a73344fe94a-670ee.jpg 1.5x,\n/static/salty_egg-8058f3f26913fea3b6a89a73344fe94a-e72f0.jpg 2x,\n/static/salty_egg-8058f3f26913fea3b6a89a73344fe94a-a0b5c.jpg 3x","srcWebp":"/static/salty_egg-8058f3f26913fea3b6a89a73344fe94a-dc95d.webp","srcSetWebp":"/static/salty_egg-8058f3f26913fea3b6a89a73344fe94a-dc95d.webp 1x,\n/static/salty_egg-8058f3f26913fea3b6a89a73344fe94a-23c19.webp 1.5x,\n/static/salty_egg-8058f3f26913fea3b6a89a73344fe94a-312b2.webp 2x,\n/static/salty_egg-8058f3f26913fea3b6a89a73344fe94a-aa8fc.webp 3x"}}]}}}}]},"pages":null,"parts":null},"layoutContext":{}}

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(264);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(129);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.guery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(33);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _typography = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var config = __webpack_require__(12);
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Template.prototype.render = function render() {
	    var _props = this.props,
	        location = _props.location,
	        children = _props.children;
	
	    var header = void 0;
	
	    var rootPath = '/';
	    if (false) {
	      rootPath = __PATH_PREFIX__ + '/';
	    }
	
	    if (location.pathname === rootPath) {
	      // header = (
	      //   <h1
	      //     style={{
	      //       //...scale(1.5),
	      //       ...scale(1.0),
	      //       //marginBottom: rhythm(1.5),
	      //       marginBottom: rhythm(1.0),
	      //       marginTop: 0,
	      //     }}
	      //   >
	      //     <Link
	      //       style={{
	      //         boxShadow: 'none',
	      //         textDecoration: 'none',
	      //         color: 'inherit',
	      //       }}
	      //       to={'/'}
	      //     >
	      //       {config.siteTitle}
	      //     </Link>
	      //   </h1>
	      // )
	      header = null;
	    } else {
	      header = _react2.default.createElement(
	        'h3',
	        {
	          style: {
	            fontFamily: 'Montserrat, sans-serif',
	            marginTop: 0
	            //marginBottom: rhythm(-1),
	          }
	        },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            style: {
	              boxShadow: 'none',
	              textDecoration: 'none',
	              color: 'inherit'
	            },
	            to: '/'
	          },
	          config.siteTitle
	        )
	      );
	    }
	    return _react2.default.createElement(
	      'div',
	      {
	        style: {
	          marginLeft: 'auto',
	          marginRight: 'auto',
	          maxWidth: (0, _typography.rhythm)(24),
	          padding: (0, _typography.rhythm)(1.5) + ' ' + (0, _typography.rhythm)(3 / 4)
	        }
	      },
	      header,
	      children()
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	exports.default = Template;
	
	//eslint-disable-next-line no-undef
	
	var guery = exports.guery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-7a47716827a61c854a5e.js